import {withFormik} from "formik";
import * as yup from "yup"
import {englishCharRegExp} from "../../../services/regex"
import {isNotEmpty} from "../../../helpers/functions";
import httpClient from "../../../services/httpClient";
import {eventsApi} from "../../../constans/apiUrls";
import {EventFileType} from "../../../constans/enumTypes";
import {IEventData} from "../../../contracts/data/event";
import InnerEventForm from "../../../components/FormTemplates/event/InnerEventForm";


const eventFormValidationSchema = yup.object().shape({
    title: yup.string().required("عنوان الزامی میباشد"),
    time_event: yup.string().required("زمان رویداد الزامی میباشد"),
    date_event_jalali: yup.string().required("تاریخ رویداد الزامی میباشد"),
    slug: yup.string().required("نامک الزامی میباشد").matches(englishCharRegExp, "حروف نامک باید انگلیسی باشد"),
    image: yup.string().required("عکس رویداد الزامی میباشد"),
})

interface IEventFormProps {
    formType?: string,
}

const EventForm = withFormik<IEventFormProps, IEventData>({
    mapPropsToValues: props => ({
        id: 0,
        title: '',
        slug: '',
        summary: '',
        content: '',
        image: '',
        image_url: '',
        file: '',
        time_event: '',
        date_event: '',
        date_event_jalali: '',
        type: EventFileType.NONE,
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: eventFormValidationSchema,
    handleSubmit: async (values, formikBag) => {
        const formData = new FormData();
        if (values.image && isNotEmpty(values.image) && typeof values.image === 'object') {
            formData.append('image', values.image)
        }
        values.slug = values.slug.replaceAll(" ", "_")
        formData.append('data', JSON.stringify(values));
        if (formikBag.props.formType === 'create') {
            await httpClient().post(eventsApi.create, formData)
                .then(response => {
                    if(response.status === 201 || response.status === 200 ){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        } else if (formikBag.props.formType === 'edit') {
            values.slug = values.slug.replaceAll(" ", "_")
            await httpClient().put(`${eventsApi.update}/${values.id}`, formData)
                .then(response => {
                    if(response.status === 200){
                        formikBag.setStatus({
                            ...formikBag.props,
                            result: response.data
                        })
                    }
                })
                .catch(error => formikBag.setStatus({
                    ...formikBag.props,
                    result: error.response.data
                }))
        }
    },
    displayName: 'EventForm'
})(InnerEventForm)

export default EventForm